var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbnormalBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2607 11.0215V6.25556M11.2607 14.554V14.5959M17.5607 18.5652H4.96082C3.23975 18.5652 1.78732 17.4775 1.33036 15.9894C1.13529 15.3541 1.37497 14.6925 1.74158 14.1291L8.04151 3.26627C9.51752 0.998154 13.004 0.998157 14.48 3.26628L20.7799 14.1291C21.1465 14.6925 21.3862 15.3541 21.1911 15.9894C20.7342 17.4775 19.2817 18.5652 17.5607 18.5652Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbnormalBot);
export default __webpack_public_path__ + "static/media/abnormal-bot.db76ffd3fdb8ad0a081b95cb6d5f796e.svg";
export { ForwardRef as ReactComponent };